import React, {useContext, useState} from "react";
import styles from "../styles/components/SermonManagerPanel.module.css";
import EditSermonForm from "./EditSermonForm";
import Styles from "../styles/pages/ServicePlanner.module.css";
import { load_fetch, isUserInRole } from "../pr_utils";
import NewSermonForm from "./NewSermonForm";
import { AuthContext } from "../AuthContext";
import { Navigate } from "react-router-dom";



const SermonManagerPanel = ({ sermons, updateSermonList }) => {
    const sermonList = Object.values(sermons);
    const [view, setView] = useState('SHOW_SERMON_LIST');
    const [selectedSermon, setSelectedSermon] = useState(null);
    const [editingSermon, setEditingSermon] = useState(false);
    const [insertingSermon, setInsertingSermon] = useState(false);
    const { authStatus } = useContext(AuthContext);


    const saveEditedSermon = (editedSermonData) => {

        editedSermonData.operation = "UPDATE_SERMON";

        load_fetch("Sermon_Handler.php", editedSermonData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                // Update the sermon list in the parent page
                const sermonArray = Object.values(data['DATA']);
                updateSermonList(sermonArray);

                // Update the sermon being edited in this component
                setSelectedSermon(data['UPDATED_SERMON']);


                // Close the form
                cancelEditSermon();
            }

        });
    }

    const handleInsertNewSermon = (newSermonData) => {

        newSermonData.operation = "INSERT_SERMON";

        load_fetch("Sermon_Handler.php", newSermonData, (data) => {
            if(!data['ERROR'] && !data['error']) {
                // Update the sermon list in the parent page
                const sermonArray = Object.values(data['DATA']);
                updateSermonList(sermonArray);

                // Close the form
                cancelInsertNewSermon();
            }

        });
    }

    const sortedSermons = () => {
        return Object.values(sermons).sort((a, b) => {
            return b.sermon_date.localeCompare(a.sermon_date);
        });
    }
    const handleSermonClicked = (sermon) => {
        setSelectedSermon(sermon);
        setView('VIEW_SERMON_DETAILS');
    }
    const reshowSermonList = () => {
        setSelectedSermon(null);
        setView('SHOW_SERMON_LIST');
    }
    const editSermon = () => {
        if(!selectedSermon) {
            return;
        }

        setView('EDITING_SERMON');
        setEditingSermon(true);
    }
    const cancelEditSermon = () => {
        setView('VIEW_SERMON_DETAILS');
        setEditingSermon(false);
    }
    const toggleInsertSermon = () => {
        if(insertingSermon) {
            setInsertingSermon(false);
            setView('SHOW_SERMON_LIST');
        } else {
            setView('SHOW_NEW_SERMON_FORM');
            setInsertingSermon(true);
            setEditingSermon(false);
            setSelectedSermon(false);
        }
    }
    const cancelInsertNewSermon = () => {
        setInsertingSermon(false);
        setView("SHOW_SERMON_LIST");
    }

    // Block unauthenticated users or non-admins
    if (!authStatus || !isUserInRole(authStatus, ['ADMIN', 'SERVICE_EDITOR'])) {
        return <Navigate to="/" />;
    }

    return (
        <div className={styles.panel}>
            <h2>Sermon Manager</h2>

            <button className={styles.menuButton} onClick={toggleInsertSermon}>Insert New Sermon</button>


            {view === 'SHOW_SERMON_LIST' ?
            <table className={styles.sermonTable}>
                <thead>
                <tr>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Bible Text</th>
                    <th>Description</th>
                    <th>Recording?</th>
                </tr>
                </thead>
                <tbody>
                {sortedSermons().map(sermon => (
                    <tr key={sermon.sermon_id} onClick={() => handleSermonClicked(sermon)}>
                        <td>{sermon.sermon_date}</td>
                        <td>{sermon.title}</td>
                        <td>{sermon.bible_text}</td>
                        <td>{sermon.description || "—"}</td>
                        <td>{sermon.rumble_url || sermon.spotify_link || sermon.youtube_url ? "Yes" : "No"}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        : ''}

            {view === 'VIEW_SERMON_DETAILS' && selectedSermon && (
                <div className={styles.sermonDetails}>
                    <div className={Styles.buttonBar}>
                        <button className={styles.menuButton} onClick={reshowSermonList}>Back to Sermon List</button>
                        <button className={styles.menuButton} onClick={editSermon}>Edit Sermon</button>
                    </div>
                    <h3>Selected Sermon</h3>
                    <dl>
                        <div className={styles.detailRow}>
                            <dt>Title:</dt>
                            <dd>{selectedSermon.title}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Bible Text:</dt>
                            <dd>{selectedSermon.bible_text}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Description:</dt>
                            <dd>{selectedSermon.description || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Sermon Date:</dt>
                            <dd>{selectedSermon.sermon_date || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Rumble URL:</dt>
                            <dd>{selectedSermon.rumble_url || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Spotify Link:</dt>
                            <dd>{selectedSermon.spotify_link || '—'}</dd>
                        </div>
                        <div className={styles.detailRow}>
                            <dt>Youtube URL:</dt>
                            <dd>{selectedSermon.youtube_url || '—'}</dd>
                        </div>
                    </dl>
                </div>
            )}




            {editingSermon && selectedSermon && (
                <EditSermonForm sermon={selectedSermon} onCancel={cancelEditSermon} onSave={saveEditedSermon}/>
            )}

            {insertingSermon && (
                <NewSermonForm onSubmit={handleInsertNewSermon} />
            )}

        </div>
    );
};

export default SermonManagerPanel;
